import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../layouts/full-layout/breadcrumb/Breadcrumb";
import FeatherIcon from "feather-icons-react";
import {
  ChangeQuestionStatus,
  GetAllQuestions,
} from "../../../../services/human-resource";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Card,
  CardContent,
  TableHead,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TableFooter,
  IconButton,
  TableSortLabel,
  TableContainer,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { routes } from "../../../../routes/routes";
import { useNavigate } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import swal from "sweetalert";

const BCrumb = [
  {
    to: "/",
    title: "HR Management",
  },
  {
    title: "All Question",
  },
];

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const AllQuestion = () => {
  const [questions, setQuestions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("Id");
  const [totalRecords, setTotalRecords] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getquestions();
  }, [rowsPerPage, searchValue, valueToOrderBy, orderDirection, page]);

  const getquestions = async () => {
    const start = rowsPerPage * page;
    const length = rowsPerPage;
    const sortValue = `${valueToOrderBy} ${orderDirection}`;
    const searchKeyword = searchValue ? searchValue : null;
    const data = {
      start: 0,
      length: 1000,
      sortExpression: sortValue,
      searchKeyword: searchKeyword,
    };
    try {
      const response = await GetAllQuestions(data);
      if (response?.status === 200) {
        setQuestions(response?.data?.result);
        setTotalRecords(response?.data?.totalRecords);
        const uniqueCategories = [
          ...new Set(
            response.data.result
              .map((x) => x.questionCategory)
              .filter(Boolean)
          ),
        ];

        setCategories(uniqueCategories);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  const handleChangeSwitch = (status, id) => {
    swal({
      title: "Confirmation",
      text: "Do you want to change the status?",
      icon: "warning",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        handleConfirmDelete(status, id);
      }
    });
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleConfirmDelete = async (status, id) => {
    try {
      const data = {
        questionId: id,
        status: status === 1 ? 0 : 1, // Toggle the status
      };
      const response = await ChangeQuestionStatus(data);
      if (response?.status === 200) {
        getquestions();
        toast.success("Question Status Updated Successfully");
      }
    } catch (error) {
      console.log("Error updating status", error);
    }
  };
  // 👇 Add here
  const filteredQuestions = questions.filter(
    (q) =>
      !selectedCategory ||
      q.questionCategory === selectedCategory
  );

  const paginatedQuestions = filteredQuestions.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  return (
    <>
      <Breadcrumb title="All Question" items={BCrumb} />
      <Card sx={{ p: 0 }}>
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>All Questions</Box>
        </Box>
        <CardContent>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
          >
            <Grid container spacing={3} sx={{ flex: 1 }}>
              <Grid item lg={3} md={3} sm={12}>
                <CustomTextField
                  id="search"
                  placeholder="Search Question..."
                  size="small"
                  type="search"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setPage(0);
                  }}
                />
              </Grid>

              <Grid item lg={3} md={3} sm={12}>
                <FormControl fullWidth size="small">
                  <InputLabel>Question Category</InputLabel>
                  <Select
                    value={selectedCategory}
                    label="Question Category"
                    onChange={(e) => {
                      setSelectedCategory(e.target.value);
                      setPage(0);
                    }}
                  >
                    <MenuItem value="">All</MenuItem>

                    {categories.map((cat) => (
                      <MenuItem key={cat} value={cat}>
                        {cat}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(routes?.addQuestion?.match)}
            >
              Add Question
            </Button>
          </Box>
        </CardContent>
        <CardContent>
          <Grid item lg={12} md={12} sm={12} style={{ overflow: "auto" }}>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 450, overflow: "auto" }}
            >
              <Table
                aria-label="custom pagination table"
                stickyHeader
                sx={{ whiteSpace: "nowrap" }}
              >
                <TableHead sx={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={valueToOrderBy === "Question"}
                        direction={
                          valueToOrderBy === "Question" ? orderDirection : "desc"
                        }
                        onClick={() => handlRequestSort("Question")}
                      >
                        Question
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={valueToOrderBy === "QuestionCategory"}
                        direction={
                          valueToOrderBy === "QuestionCategory"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("QuestionCategory")}
                      >
                        QuestionCategory
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedQuestions.map((rows) => (
                    <TableRow key={rows?.id}>
                      <TableCell
                        sx={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          maxWidth: 300,
                        }}
                      >
                        {rows?.question}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.questionCategory}
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Edit" placement="left-start">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate(
                                routes?.editQuestion.build(`${rows.id}`, {
                                  id: `${rows?.id}`,
                                })
                              )
                            }
                          >
                            <FeatherIcon icon="edit-2" width="16" />
                          </IconButton>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="View" placement="top">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate(
                                routes?.questionView.build(`${rows.id}`, {
                                  id: `${rows?.id}`,
                                })
                              )
                            }
                          >
                            <RemoveRedEyeOutlinedIcon width="16" />
                          </IconButton>
                        </Tooltip>
                        &nbsp;

                        <Tooltip
                          title={
                            rows.status === 1
                              ? "Deactivate Question"
                              : "Activate Question"
                          }
                          placement="top"
                        >
                          <Switch
                            checked={rows.status === 1}
                            onChange={() => {
                              handleChangeSwitch(rows.status, rows.id);
                            }}
                            size="small"
                          />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow></TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to delete this Question?
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleConfirmDelete} color="error">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
          <Box style={{ display: "flex", justifyContent: "flex-end" }}>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                { label: "All", value: totalRecords },
              ]}
              colSpan={10}
              count={selectedCategory ? filteredQuestions.length : questions.length}
              rowsPerPage={totalRecords > 0 ? rowsPerPage : 0}
              page={page}
              SelectProps={{
                inputprops: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};